// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/heros/hero-image_2-small.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/heros/hero-image_2-large.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* Mobile Screen */

  @media screen and (max-width: 767px) {

    .main_hero_container {
      height: 0;
      background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center;
      background-size: cover;
      min-height: 350px;
    }

    body {
      min-width: 375px;
    }

    /* Navbar */

    .skip_link {
      margin-left: 10px;
      transform: translateY(-230%);
    }

    .skip_link:focus {
      transform: translateY(1%);
    }

    .bar {
      display: block;
      width: 30px;
      height: 2px;
      margin: 3px 0 3px 0;
    }

    .hamburger-menu {
      border: none;
      background: none;
      visibility:visible;
      display: grid;
      justify-content: center;
      align-items: center;
      align-content: center;
      width: 44px;
      height: 44px;
      margin-right: 20px;
      justify-self: end;
    }

    .img_logo {
      margin-left: 20px;
    }

    .app_bar {
      display: grid;
      height: 74px;
      align-items: center;
      width: auto;
      grid-template-columns: repeat(2, 1fr);
    }

    .navbar_list {
      top: 75px;
      width: 105%;
      right: -110%;
      position: fixed;
      display: grid;
      justify-content: center;
      justify-items: center;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: repeat(3, 50px);
      transition: 0.3s;
      background-color: #b2ff9e;
      border-top: 2px solid black;
      border-bottom: 2px solid black;
    }

    .navbar_item_container {
      display: grid;
      align-items: center;
      justify-items: center;
      width: 80px;
      height: 44px;
      margin: 0 10px;
    }

    .navbar_list.active {
      right: 0;
  }

    /* Main Hero Image */

    .container_main_hero_image {
      padding: 0px;
    }

    .hero_image {
      max-width: 100%;
      height: 300px;
      object-position: 50% 50%;
    }

    /* List of Restaurant Card */

    .popular_restaurant_title {
      font-size: 30px;
    }

    .restaurant-list {
      margin-top: 20px;
      display: grid;
      justify-items: center;
      align-items: start;
      grid-template-columns: repeat(1, 2fr);
      grid-template-rows: 510px;
      grid-auto-rows: 510px;
    }

    .restaurant_card {
      width: 300px;
      display: grid;
      justify-items: center;
      align-items: center;
      margin: 30px 0;
      padding: 15px 20px;
      background-color: #ffffff;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
      border-radius: 20px;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: 220px 250px;
    }

    .container_restaurant {
      order: 2;
      display: grid;
      justify-items: center;
      align-items: center;
      row-gap: 10px;
      grid-template-rows: max-content;
    }

    .container_restaurant_image {
      order: 1;
    }

    .restaurant_image {
      width: 250px;
      height: 200px;
      border-radius: 10px;
    }

    .restaurant_title {
      font-size: 23px;
    }

    .restaurant_description {
      font-size: 16px;
      width: 250px;
      height: 95px;
      line-height: 1.2rem;
      align-self: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box !important;
      -webkit-line-clamp: 4;
      -webkit-box-orient: horizontal;
      white-space: normal;
    }

    .container_rating_location {
      font-size: 16px;
      justify-self: start;
    }

    .button_book_now {
      margin-top: 20px;
    }

    /* Footer */

    .container_footer {
      width: auto;
      margin-top: 80px;
      height: auto;
      display: grid;
      justify-items: center;
      align-items: center;
      padding: 30px 0;
      background-color: #f6fff8;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: 90px 80px 30px;
      border-top: 1px solid var(--neutral-2, #DEE5ED);
    }

    .footer_main_title {
      text-align: center;
      font-size: 25px;
    }

    .copyright {
      font-size: 18px;
      order: 3;
    }

    .follow_us {
      text-align: center;
    }

    .container-social-media {
      row-gap: 0;
    }

    .list-social-media {
      display: grid;
      font-size: 18px;
      list-style: none;
      column-gap: 15px;
      grid-template-columns: 70px 70px 70px 70px;
    }

    .social_media_item_container {
      width: auto;
      display: grid;
      justify-items: center;
      align-items: center;
      height: 45px;
      width: 85px;
      margin-right: 60px;
    }
  }

  /* Tablet Screen */

  @media screen and (min-width: 768px) and (max-width: 1024px) {
    
    /* Main Hero Image */

    .hero_image{
      max-width: 100%;
    }

    .second_section {
      width: auto;
      align-items: center;
      justify-items: center;
    }
    
    .restaurant-list {
      display: grid;
      justify-content: center;
      justify-items: center;
      column-gap: 40px;
      row-gap: 40px;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(auto-fill, 500px);
    }

    .resto {
      width: 300px;
      height: 500px;
    }

    .restaurant_card {
      width: 300px;
      display: grid;
      justify-items: center;
      align-items: center;
      margin: 30px 0;
      padding: 15px 20px;
      background-color: #ffffff;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
      border-radius: 20px;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: 220px 250px;
    }

    .container_restaurant {
      order: 2;
      display: grid;
      justify-items: center;
      align-items: center;
      row-gap: 10px;
      grid-template-rows: max-content;
    }

    .container_restaurant_image {
      order: 1;
    }

    .restaurant_image {
      width: 250px;
      height: 200px;
      border-radius: 10px;
    }

    .restaurant_title {
      font-size: 23px;
    }

    .restaurant_description {
      font-size: 16px;
      width: 250px;
      height: 100px;
      line-height: 1.2rem;
      align-self: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box !important;
      -webkit-line-clamp: 4;
      -webkit-box-orient: horizontal;
      white-space: normal;
    }

    .container_rating_location {
      font-size: 16px;
      justify-self: start;
    }

    .button_book_now {
      margin-top: 20px;
    }

    /* Footer */

    .container_footer {
      width: auto;
      margin-top: 80px;
      height: auto;
      display: grid;
      justify-items: center;
      align-items: center;
      padding: 30px 0;
      background-color: #f6fff8;
      row-gap: 20px;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: 100px 75px 35px;
      border-top: 1px solid var(--neutral-2, #DEE5ED);
    }

    .footer_main_title {
      text-align: center;
      font-size: 35px;
    }

    .follow_us {
      font-size: 25px;
      text-align: center;
    }

    .list-social-media {
      font-size: 22px;
      display: grid;
      justify-items: start;
      list-style: none;
      column-gap: 48px;
      grid-template-columns: 80px 70px 80px 60px;
    }

    .copyright {
      font-size: 22px;
      order: 3;
    }
  }

/* Laptop/Desktop Screen */

@media screen and (min-width: 1025px) and (max-width: 1380px) {

  .main_hero_container {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center;
  }

  .hero_image {
    max-width: 100%;
  }

  .resto {
    height: 250px;
  }

  .restaurant-list {
    display: grid;
    justify-content: center;
    justify-items: center;
    row-gap: 40px;
    column-gap: 40px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(auto-fill, 280px);
  }

  .restaurant_card {
    width: 500px;
    grid-template-columns: 250px auto;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/mainResponsive.css"],"names":[],"mappings":"EAAE,kBAAkB;;EAElB;;IAEE;MACE,SAAS;MACT,0DAAwE;MACxE,sBAAsB;MACtB,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA,WAAW;;IAEX;MACE,iBAAiB;MACjB,4BAA4B;IAC9B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,cAAc;MACd,WAAW;MACX,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,qBAAqB;MACrB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,YAAY;MACZ,mBAAmB;MACnB,WAAW;MACX,qCAAqC;IACvC;;IAEA;MACE,SAAS;MACT,WAAW;MACX,YAAY;MACZ,eAAe;MACf,aAAa;MACb,uBAAuB;MACvB,qBAAqB;MACrB,qCAAqC;MACrC,mCAAmC;MACnC,gBAAgB;MAChB,yBAAyB;MACzB,2BAA2B;MAC3B,8BAA8B;IAChC;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,qBAAqB;MACrB,WAAW;MACX,YAAY;MACZ,cAAc;IAChB;;IAEA;MACE,QAAQ;EACZ;;IAEE,oBAAoB;;IAEpB;MACE,YAAY;IACd;;IAEA;MACE,eAAe;MACf,aAAa;MACb,wBAAwB;IAC1B;;IAEA,4BAA4B;;IAE5B;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,qBAAqB;MACrB,kBAAkB;MAClB,qCAAqC;MACrC,yBAAyB;MACzB,qBAAqB;IACvB;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,qBAAqB;MACrB,mBAAmB;MACnB,cAAc;MACd,kBAAkB;MAClB,yBAAyB;MACzB,0CAA0C;MAC1C,mBAAmB;MACnB,qCAAqC;MACrC,+BAA+B;IACjC;;IAEA;MACE,QAAQ;MACR,aAAa;MACb,qBAAqB;MACrB,mBAAmB;MACnB,aAAa;MACb,+BAA+B;IACjC;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,YAAY;MACZ,mBAAmB;MACnB,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;MAChB,uBAAuB;MACvB,+BAA+B;MAC/B,qBAAqB;MACrB,8BAA8B;MAC9B,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;IAClB;;IAEA,WAAW;;IAEX;MACE,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,aAAa;MACb,qBAAqB;MACrB,mBAAmB;MACnB,eAAe;MACf,yBAAyB;MACzB,qCAAqC;MACrC,kCAAkC;MAClC,+CAA+C;IACjD;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,QAAQ;IACV;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,gBAAgB;MAChB,0CAA0C;IAC5C;;IAEA;MACE,WAAW;MACX,aAAa;MACb,qBAAqB;MACrB,mBAAmB;MACnB,YAAY;MACZ,WAAW;MACX,kBAAkB;IACpB;EACF;;EAEA,kBAAkB;;EAElB;;IAEE,oBAAoB;;IAEpB;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,mBAAmB;MACnB,qBAAqB;IACvB;;IAEA;MACE,aAAa;MACb,uBAAuB;MACvB,qBAAqB;MACrB,gBAAgB;MAChB,aAAa;MACb,qCAAqC;MACrC,4CAA4C;IAC9C;;IAEA;MACE,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,qBAAqB;MACrB,mBAAmB;MACnB,cAAc;MACd,kBAAkB;MAClB,yBAAyB;MACzB,0CAA0C;MAC1C,mBAAmB;MACnB,qCAAqC;MACrC,+BAA+B;IACjC;;IAEA;MACE,QAAQ;MACR,aAAa;MACb,qBAAqB;MACrB,mBAAmB;MACnB,aAAa;MACb,+BAA+B;IACjC;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;MAChB,uBAAuB;MACvB,+BAA+B;MAC/B,qBAAqB;MACrB,8BAA8B;MAC9B,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;IAClB;;IAEA,WAAW;;IAEX;MACE,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,aAAa;MACb,qBAAqB;MACrB,mBAAmB;MACnB,eAAe;MACf,yBAAyB;MACzB,aAAa;MACb,qCAAqC;MACrC,mCAAmC;MACnC,+CAA+C;IACjD;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,aAAa;MACb,oBAAoB;MACpB,gBAAgB;MAChB,gBAAgB;MAChB,0CAA0C;IAC5C;;IAEA;MACE,eAAe;MACf,QAAQ;IACV;EACF;;AAEF,0BAA0B;;AAE1B;;EAEE;IACE,0DAAwE;EAC1E;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,4CAA4C;EAC9C;;EAEA;IACE,YAAY;IACZ,iCAAiC;EACnC;;AAEF","sourcesContent":["  /* Mobile Screen */\n\n  @media screen and (max-width: 767px) {\n\n    .main_hero_container {\n      height: 0;\n      background: url('../public/images/heros/hero-image_2-small.webp') center;\n      background-size: cover;\n      min-height: 350px;\n    }\n\n    body {\n      min-width: 375px;\n    }\n\n    /* Navbar */\n\n    .skip_link {\n      margin-left: 10px;\n      transform: translateY(-230%);\n    }\n\n    .skip_link:focus {\n      transform: translateY(1%);\n    }\n\n    .bar {\n      display: block;\n      width: 30px;\n      height: 2px;\n      margin: 3px 0 3px 0;\n    }\n\n    .hamburger-menu {\n      border: none;\n      background: none;\n      visibility:visible;\n      display: grid;\n      justify-content: center;\n      align-items: center;\n      align-content: center;\n      width: 44px;\n      height: 44px;\n      margin-right: 20px;\n      justify-self: end;\n    }\n\n    .img_logo {\n      margin-left: 20px;\n    }\n\n    .app_bar {\n      display: grid;\n      height: 74px;\n      align-items: center;\n      width: auto;\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    .navbar_list {\n      top: 75px;\n      width: 105%;\n      right: -110%;\n      position: fixed;\n      display: grid;\n      justify-content: center;\n      justify-items: center;\n      grid-template-columns: repeat(1, 1fr);\n      grid-template-rows: repeat(3, 50px);\n      transition: 0.3s;\n      background-color: #b2ff9e;\n      border-top: 2px solid black;\n      border-bottom: 2px solid black;\n    }\n\n    .navbar_item_container {\n      display: grid;\n      align-items: center;\n      justify-items: center;\n      width: 80px;\n      height: 44px;\n      margin: 0 10px;\n    }\n\n    .navbar_list.active {\n      right: 0;\n  }\n\n    /* Main Hero Image */\n\n    .container_main_hero_image {\n      padding: 0px;\n    }\n\n    .hero_image {\n      max-width: 100%;\n      height: 300px;\n      object-position: 50% 50%;\n    }\n\n    /* List of Restaurant Card */\n\n    .popular_restaurant_title {\n      font-size: 30px;\n    }\n\n    .restaurant-list {\n      margin-top: 20px;\n      display: grid;\n      justify-items: center;\n      align-items: start;\n      grid-template-columns: repeat(1, 2fr);\n      grid-template-rows: 510px;\n      grid-auto-rows: 510px;\n    }\n\n    .restaurant_card {\n      width: 300px;\n      display: grid;\n      justify-items: center;\n      align-items: center;\n      margin: 30px 0;\n      padding: 15px 20px;\n      background-color: #ffffff;\n      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);\n      border-radius: 20px;\n      grid-template-columns: repeat(1, 1fr);\n      grid-template-rows: 220px 250px;\n    }\n\n    .container_restaurant {\n      order: 2;\n      display: grid;\n      justify-items: center;\n      align-items: center;\n      row-gap: 10px;\n      grid-template-rows: max-content;\n    }\n\n    .container_restaurant_image {\n      order: 1;\n    }\n\n    .restaurant_image {\n      width: 250px;\n      height: 200px;\n      border-radius: 10px;\n    }\n\n    .restaurant_title {\n      font-size: 23px;\n    }\n\n    .restaurant_description {\n      font-size: 16px;\n      width: 250px;\n      height: 95px;\n      line-height: 1.2rem;\n      align-self: center;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box !important;\n      -webkit-line-clamp: 4;\n      -webkit-box-orient: horizontal;\n      white-space: normal;\n    }\n\n    .container_rating_location {\n      font-size: 16px;\n      justify-self: start;\n    }\n\n    .button_book_now {\n      margin-top: 20px;\n    }\n\n    /* Footer */\n\n    .container_footer {\n      width: auto;\n      margin-top: 80px;\n      height: auto;\n      display: grid;\n      justify-items: center;\n      align-items: center;\n      padding: 30px 0;\n      background-color: #f6fff8;\n      grid-template-columns: repeat(1, 1fr);\n      grid-template-rows: 90px 80px 30px;\n      border-top: 1px solid var(--neutral-2, #DEE5ED);\n    }\n\n    .footer_main_title {\n      text-align: center;\n      font-size: 25px;\n    }\n\n    .copyright {\n      font-size: 18px;\n      order: 3;\n    }\n\n    .follow_us {\n      text-align: center;\n    }\n\n    .container-social-media {\n      row-gap: 0;\n    }\n\n    .list-social-media {\n      display: grid;\n      font-size: 18px;\n      list-style: none;\n      column-gap: 15px;\n      grid-template-columns: 70px 70px 70px 70px;\n    }\n\n    .social_media_item_container {\n      width: auto;\n      display: grid;\n      justify-items: center;\n      align-items: center;\n      height: 45px;\n      width: 85px;\n      margin-right: 60px;\n    }\n  }\n\n  /* Tablet Screen */\n\n  @media screen and (min-width: 768px) and (max-width: 1024px) {\n    \n    /* Main Hero Image */\n\n    .hero_image{\n      max-width: 100%;\n    }\n\n    .second_section {\n      width: auto;\n      align-items: center;\n      justify-items: center;\n    }\n    \n    .restaurant-list {\n      display: grid;\n      justify-content: center;\n      justify-items: center;\n      column-gap: 40px;\n      row-gap: 40px;\n      grid-template-columns: repeat(2, 1fr);\n      grid-template-rows: repeat(auto-fill, 500px);\n    }\n\n    .resto {\n      width: 300px;\n      height: 500px;\n    }\n\n    .restaurant_card {\n      width: 300px;\n      display: grid;\n      justify-items: center;\n      align-items: center;\n      margin: 30px 0;\n      padding: 15px 20px;\n      background-color: #ffffff;\n      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);\n      border-radius: 20px;\n      grid-template-columns: repeat(1, 1fr);\n      grid-template-rows: 220px 250px;\n    }\n\n    .container_restaurant {\n      order: 2;\n      display: grid;\n      justify-items: center;\n      align-items: center;\n      row-gap: 10px;\n      grid-template-rows: max-content;\n    }\n\n    .container_restaurant_image {\n      order: 1;\n    }\n\n    .restaurant_image {\n      width: 250px;\n      height: 200px;\n      border-radius: 10px;\n    }\n\n    .restaurant_title {\n      font-size: 23px;\n    }\n\n    .restaurant_description {\n      font-size: 16px;\n      width: 250px;\n      height: 100px;\n      line-height: 1.2rem;\n      align-self: center;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box !important;\n      -webkit-line-clamp: 4;\n      -webkit-box-orient: horizontal;\n      white-space: normal;\n    }\n\n    .container_rating_location {\n      font-size: 16px;\n      justify-self: start;\n    }\n\n    .button_book_now {\n      margin-top: 20px;\n    }\n\n    /* Footer */\n\n    .container_footer {\n      width: auto;\n      margin-top: 80px;\n      height: auto;\n      display: grid;\n      justify-items: center;\n      align-items: center;\n      padding: 30px 0;\n      background-color: #f6fff8;\n      row-gap: 20px;\n      grid-template-columns: repeat(1, 1fr);\n      grid-template-rows: 100px 75px 35px;\n      border-top: 1px solid var(--neutral-2, #DEE5ED);\n    }\n\n    .footer_main_title {\n      text-align: center;\n      font-size: 35px;\n    }\n\n    .follow_us {\n      font-size: 25px;\n      text-align: center;\n    }\n\n    .list-social-media {\n      font-size: 22px;\n      display: grid;\n      justify-items: start;\n      list-style: none;\n      column-gap: 48px;\n      grid-template-columns: 80px 70px 80px 60px;\n    }\n\n    .copyright {\n      font-size: 22px;\n      order: 3;\n    }\n  }\n\n/* Laptop/Desktop Screen */\n\n@media screen and (min-width: 1025px) and (max-width: 1380px) {\n\n  .main_hero_container {\n    background: url('../public/images/heros/hero-image_2-large.webp') center;\n  }\n\n  .hero_image {\n    max-width: 100%;\n  }\n\n  .resto {\n    height: 250px;\n  }\n\n  .restaurant-list {\n    display: grid;\n    justify-content: center;\n    justify-items: center;\n    row-gap: 40px;\n    column-gap: 40px;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(auto-fill, 280px);\n  }\n\n  .restaurant_card {\n    width: 500px;\n    grid-template-columns: 250px auto;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
